import { Flex } from "@chakra-ui/react";
import { memo } from "react";
import { FieldRawProps } from "../../types";
import { PhotoBlackboardIcon } from "components/icon";

const ImageHasBlackboardRaw = (props: FieldRawProps) => {
  return (
    <>
      <Flex
        position={"absolute"}
        top={"50%"}
        left="50%"
        transform={"translate(-50%, -50%)"}
        textAlign={"center"}
      >
        <PhotoBlackboardIcon
          mx={"auto"}
          w="50%"
          h="50%"
          filter={"grayscale(100%)"}
          opacity={0.3}
        />
      </Flex>
    </>
  );
};

export default memo(ImageHasBlackboardRaw);
